<template>
  <section class="timeTplList p-4 space-y-4">
    <viewTitle
      title="业务管理 / 基础数据管理 / 预约时间模板"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%">
        <el-button
          type="primary"
          size="small"
          v-has="['c-base-mp-mtime-add']"
          @click="
            $router.push({
              path: '/rhqy/service/appoint/timeTplList/addAndEdit',
              query: {
                type: 'add'
              }
            })
          "
          >新建模板</el-button
        >
        <!-- </div>
    </section> -->
        <!-- 按钮组2 -->
        <!-- <section class="controler"> -->
        <!-- <div class="ctrLeft" style="width: 100%;"> -->
        <span class="rectl text-sm">生效时间</span>
        <el-select
          clearable
          class="ctl rectl"
          @clear="params.state = 0"
          v-model="params.state"
          placeholder="请选择生效时间"
          @change="changeValidTime"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateOption"
            :key="index"
          ></el-option>
        </el-select>
        <span class="rectl text-sm">模板状态</span>
        <el-select
          clearable
          class="ctl rectl"
          @clear="params.stateTpl = 0"
          v-model="params.stateTpl"
          placeholder="请选择模板状态"
          @change="changeValidTime"
        >
          <el-option
            :label="item"
            :value="index"
            v-for="(item, index) in stateTplOption"
            :key="index"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
        >
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="基地">
          <template slot-scope="scope">
            {{ baseInfo.com_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="模板名称">
          <template slot-scope="scope">
            {{ scope.row.name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="有效日期范围">
          <template slot-scope="scope">
            {{ formatTimeRange(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="重复设置">
          <template slot-scope="scope">
            {{ formatRepeatSet(scope.row.repeat_setting) }}
          </template>
        </el-table-column>
        <el-table-column label="最小可预约时间">
          <template slot-scope="scope">
            {{ formatMin(scope.row.min_booking_time) }}
          </template>
        </el-table-column>
        <el-table-column label="最大可预约时间">
          <template slot-scope="scope">
            {{ formatMax(scope.row.max_booking_day) }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="备注">
          <template slot-scope="scope">
            {{ scope.row.note || "--" }}
          </template>
        </el-table-column> -->
        <el-table-column label="生效时间">
          <template slot-scope="scope">
            <span
              v-if="formatValidTime(scope.row) === '已失效'"
              class="color99"
            >
              {{ formatValidTime(scope.row) }}
            </span>
            <span v-else>
              {{ formatValidTime(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="模板状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1" class="color5E">正常</span>
            <span v-else-if="scope.row.state === 2" class="color67">
              已禁用
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="创建时间" width="165px">
          <template slot-scope="scope">
            {{ formatTime(scope.row.create_time) }}
          </template>
        </el-table-column> -->
        <el-table-column prop="phone" label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item v-has="['c-base-mp-mtime-detail']" @click.native.stop="viewDetail(scope.row)"
                    >查看模板</el-dropdown-item
                  >
                  <el-dropdown-item v-has="['c-base-mp-mtime-update']" @click.native.stop="modifyTpl(scope.row)"
                    >修改模板</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-has="['c-base-mp-mtime-switch']"
                    @click.native.stop="delOrEnable(scope.row, 'forbid')"
                    v-if="scope.row.state === 1"
                    >禁用</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-has="['c-base-mp-mtime-switch']"
                    @click.native.stop="delOrEnable(scope.row, 'start')"
                    v-if="scope.row.state === 2"
                    >启用</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-has="['c-base-mp-mtime-delete']"
                    @click.native.stop="delOrEnable(scope.row, 'del')"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.show"
      width="30%"
      :show-close="dialogParams.title === '确认提醒'"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="font-size: 18px">
          <i
            class="el-icon-success"
            style="color: #2acdcf"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogParams.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.show = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">取 消</span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          :class="dialogParams.type === 'del' ? 'btnConfirmDanger' : ''"
          :type="dialogParams.type === 'del' ? 'danger' : 'primary'"
          size="small"
          @click="confirm"
          v-loading.fullscreen.lock="fullscreenLoading"
          v-if="dialogParams.title === '确认提醒'"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import keepAliveMinxin from "@/mixins/rh/keepAliveMinxin.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      rowDataObj: {},
      params: {
        keyword: "", // 关键字搜索
        state: 0, // 生效时间
        stateTpl: 0 // 模板状态
      },
      dialogParams: {
        show: false,
        title: "",
        content: "",
        type: ""
      },
      fullscreenLoading: false,
      maxSize: 0,
      tableData: [], // 表格数据
      stateOption: ["全部", "未生效", "生效中", "已失效"],
      stateTplOption: ["全部", "正常", "已禁用"],
      toKeepAlivePath: "/rhqy/service/appoint/timeTplList/detail/" // 当前路由访问某个页面时的不清除缓存
    };
  },

  components: {
    pagi,
    viewTitle
  },

  mixins: [mixinTableLyout, keepAliveMinxin],

  computed: {
    ...mapGetters(["baseRole", "baseInfo"]),
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mounted() {
    // setTimeout(() => {
    //   this.resizeTableHeight();
    //   window.addEventListener(
    //     "resize",
    //     e => {
    //       //  初始化表格合适高度
    //       this.resizeTableHeight();
    //       console.log(e);
    //     },
    //     false
    //   );
    // }, 500);
    // this.getList();
  },

  async activated() {
    this.getList();
  },

  created() {},

  methods: {
    // 格式化有效时间范围
    formatTimeRange(row) {
      if (row.is_permanent_valid === 1) {
        return "永久有效";
      } else {
        let str1 = String(row.begin_time);
        let str2 = String(row.end_time);
        let start = "";
        let end = "";
        if (str1.substring(0, 4) === String(moment().year())) {
          start = `${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
        } else {
          start = `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
        }
        if (str2.substring(0, 4) === String(moment().year())) {
          end = `${str2.substring(4, 6)}月
          ${str2.substring(6, 8)}日`;
        } else {
          end = `${str2.substring(0, 4)}年
          ${str2.substring(4, 6)}月
          ${str2.substring(6, 8)}日`;
        }
        return `${start} - ${end}`;
      }
    },

    // 格式化重复设置
    formatRepeatSet(arr) {
      if (arr.length === 7) {
        return "每天";
      } else {
        let str = [];
        arr.forEach(item => {
          switch (item) {
            case "1":
              str.push("周一");
              break;
            case "2":
              str.push("周二");
              break;
            case "3":
              str.push("周三");
              break;
            case "4":
              str.push("周四");
              break;
            case "5":
              str.push("周五");
              break;
            case "6":
              str.push("周六");
              break;
            case "0":
              str.push("周日");
              break;
          }
        });
        return str.join("、");
      }
    },

    // 格式化最小可预约时间
    formatMin(str) {
      if (str === 0) {
        return `无限制`;
      } else {
        return `不小于${parseFloat((str / 60 / 60).toFixed(2))}小时`;
      }
    },

    // 格式化最大可预约时间
    formatMax(str) {
      return `${str}天内`;
    },

    // 格式化生效时间
    formatValidTime(row) {
      if (Number(row.valid_state) === 1) {
        return `${row.valid_time}天后`;
      } else if (Number(row.valid_state) === 2) {
        return `生效中`;
      } else if (Number(row.valid_state) === 3) {
        return `已失效`;
      }
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/queue/admin/query_business_time_model",
        data: {
          valid_state: this.params.state,
          state: this.params.stateTpl,
          keyword: this.params.keyword,
          page_size: this.pageSize,
          page: this.page
        }
      });
      console.log(dataObj.data.data);
      this.tableData = dataObj.data.data.data;
      this.count = dataObj.data.data.total;
    },

    // 修改生效时间
    changeValidTime() {
      this.page = 1;
      this.getList();
    },

    // 修改模板状态
    changeStateTpl() {
      this.page = 1;
      this.getList();
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 查看详情
    viewDetail(row) {
      this.$router.push({
        path: "/rhqy/service/appoint/timeTplList/detail/" + row.id
      });
    },

    // 编辑
    modifyTpl(row) {
      this.$router.push({
        path: "/rhqy/service/appoint/timeTplList/addAndEdit/" + row.id
      });
    },

    // 删除/禁用启用
    delOrEnable(row, tag) {
      this.dialogParams.type = tag;
      this.dialogParams.title = "确认提醒";
      this.dialogParams.show = true;
      this.rowDataObj = row;
      if (tag === "del") {
        this.dialogParams.content = `确定要删除“<span class="color67">${this.rowDataObj.name}</span>”吗？<br />
        未被使用的模板实例也将被一并删除！<br />
        <span class="color67">删除后不可恢复！</span>`;
      } else if (tag === "forbid") {
        this.dialogParams.content = `确定要禁用“<span class="color67">${this.rowDataObj.name}</span>”吗？<br />
        禁用后未被使用的模板实例也将被删除！`;
      } else if (tag === "start") {
        this.dialogParams.content = `确定要启用“<span class="color67">${this.rowDataObj.name}</span>”吗？<br />
        启用后模板立即生效！`;
      }
    },

    // 确认删除/禁用启用
    confirm() {
      this.dialogParams.show = false;
      let url = "";
      if (this.dialogParams.type === "del") {
        url = "/api/queue/admin/delete_business_time_model";
      } else if (
        this.dialogParams.type === "forbid" ||
        this.dialogParams.type === "start"
      ) {
        url = "/api/queue/admin/enable_business_time_model";
      }

      this.$common
        .http({
          url: url,
          data: {
            id: this.rowDataObj.id
          }
        })
        .then(res => {
          console.log(res);
          // this.dialogParams.content = `已成功删除“<span class="color67">${this.rowDataObj.name}</span>”。`;
          if (this.dialogParams.type === "del") {
            this.$common.pcToastSuccess(
              `已成功删除“${this.rowDataObj.name}”。`
            );
          } else if (this.dialogParams.type === "forbid") {
            this.$common.pcToastSuccess(
              `已成功禁用“${this.rowDataObj.name}”。`
            );
          } else if (this.dialogParams.type === "start") {
            this.$common.pcToastSuccess(
              `已成功启用“${this.rowDataObj.name}”。`
            );
          }
          // this.dialogParams.show = true;
          // this.dialogParams.title = "操作成功";
          this.getList();
          // setTimeout(() => {
          //   this.dialogParams.show = false;
          // }, 1500);
        });
    }

    // 重置高度
    // resizeTableHeight() {
    //   const BANNER_HEIGHT = 25; // 头部导航高度
    //   const PADDING = 24; // padding
    //   const ETC = 260; // 头部 和 底部导航高度
    //   var offsetHeihgt = window.innerHeight - BANNER_HEIGHT - PADDING * 2;
    //   this.maxSize = offsetHeihgt - ETC;
    // }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.timeTplList {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
}
.page-wrap {
  padding-top: 10px;
}
</style>
